import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

export default function WebModalForm({formId, formSubject}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [thankYouMessage, setThankYouMessage] = useState("");
  const [phone, setPhone] = useState("+1");
  const [country, setCountry] = useState("us");
  const [contact_form_id, setContactFormId] = useState(formId || 19145);
  const [subject, setSubject] = useState(formSubject || "Mobile App Talk to an Expert");
  const [errorMessage, setErrorMessage] = useState("");

  const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID ?? "";
  const formGuid = process.env.REACT_APP_HUBSPOT_FORM_GUID ?? "";
  const hutk = process.env.REACT_APP_HUBSPOT_HUTK ?? "";
  const hubSportApiUrl = `${process.env.REACT_APP_HUBSPOT_API_URL}/${portalId}/${formGuid}`;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (thankYouMessage) {
      const timer = setTimeout(() => {
        setThankYouMessage("");
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [thankYouMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const onSubmit = async (data, e) => {
    setIsLoading(true);
    try {
      const nameParts = data.yourName.trim().split(/\s+/);
      let fname = data.yourName;
      let lname = '';
      if (nameParts.length > 0) {
        fname = nameParts[0];
        if(nameParts.length > 1){
          lname = nameParts.slice(1).join(' ');
        }
      }
      const responseHubSport = await axios.post(hubSportApiUrl, {
        portalId,
        formGuid,
        context: {
          hutk: hutk ?? "",
          pageUri: window.location.href,
          pageName: document.title,
        },
        fields: [
          {
            name: "email",
            value: data.yourEmail,
          },
          {
            name: "firstname",
            value: fname,
          },
          {
            name: "lastname",
            value: lname,
          },
          {
            name: "phone",
            value: data.yourPhone ?? '',
          },
          // {
          //   name: "website",
          //   value: data.yourWebsite ?? '',
          // }, 
          {
            name: "text_message",
            value: data.writeMessage ?? '',
          }/*,  
          {
            name: "hs_lead_status",
            value: 'NEW',
          },
          {
            name: "lead_source",
            value: "Stripe Landing Page",
          },  */       
        ],
      },config); 
      
      const response = await axios.post(
        `${process.env.REACT_APP_CONTACT_FORM_API_URL}/${contact_form_id}/feedback`,
        {
          form_id: contact_form_id,
          subject: subject,
          Name: data.yourName,
          Email: data.yourEmail,
          Phone: data.yourPhone,
          // Website: data.yourWebsite,
          Message: data.writeMessage,
           _wpcf7_unit_tag: `wpcf7-f${contact_form_id}-o1`
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'formSubmitted',
        id: contact_form_id,
        formId: contact_form_id,
        elementId: contact_form_id,
        form_name: 'Mobile App Modal Form',
      });
      
      if (response.data.status === "mail_sent") {
        reset();
        setCountry('us');
        setPhone( "+1");
        setThankYouMessage("Thanks For Contacting Us! We will be in touch soon to schedule your free consultation.");
      } else {
        setErrorMessage("Form submission failed. " + response.data.message);
      }
    } catch (error) {
      setErrorMessage("Form submission failed. " + error.message);
    }
        finally {
      setIsLoading(false);
    }
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
    setValue("yourPhone", value);
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" {...register("form_id")} value={contact_form_id} />
        <div className="mb-[20px]">
          <input
            {...register("yourName", {
              required: true,              
            })}
            placeholder="Your Name"
            className="px-[12px] py-[6px] text-sm w-full rounded-[10px] min-h-[48px] text-[#333] bg-white border border-solid border-[#DFDFDF] mb-1 placeholder:text-[#858585]"
          />
          {errors?.yourName?.type === "required" && (
            <p className="text-[11px] text-red-600 mt-1">
              Please fill out this field.
            </p>
          )}
        </div>
        <div className="mb-[20px]">
          <input
            {...register("yourEmail", {
              required: true,
              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
            })}
            placeholder="Your Email *"
            className="px-[12px] py-[6px] text-sm  w-full rounded-[10px] min-h-[48px] text-[#333] bg-white border border-solid border-[#DFDFDF] mb-1 placeholder:text-[#858585]"
          />
         {errors?.yourEmail?.type === "required" && (
            <p className="text-[11px] text-red-600 mt-1">
              Please fill out this field.
            </p>
          )}
          {errors?.yourEmail?.type === "pattern" && (
            <p className="text-[11px] text-red-600 mt-1">
              Invalid email format.
            </p>
          )}
        </div>        
        <div className="mb-[20px]">
          <PhoneInput
            country={'us'}
            value={phone}
            onChange={handlePhoneChange}
            countryCodeEditable={false}
            inputProps={{
              placeholder: "Your Phone"
            }}
            inputClassName="px-[12px] py-[6px] text-sm w-full rounded-[10px] min-h-[45px] text-[#333] bg-[#fbfbfb] border border-solid border-[#E0E0E0] mb-1"
          />
          {errors?.yourPhone && <p className="text-[11px] text-red-600 mt-1">Please enter a valid phone number.</p>}
        </div>

        <div className="mb-[20px]">
          <textarea
            {...register("writeMessage", {
              // required: true,
              maxLength: 500,
            })}
            placeholder="Please describe your app idea...  "
            className="px-[12px] py-[6px] text-sm w-full rounded-[10px] min-h-[95px] text-[#333] bg-white border border-solid border-[#DFDFDF] mb-1 placeholder:text-[#858585]"
          />
          {/* {errors?.writeMessage?.type === "required" && (
            <p className="text-[11px] text-red-600">This field is required</p>
          )} */}
        </div>       
        <button
          type="submit"
          className="group relative w-full flex min-h-[48px] mx-auto py-3 px-10 items-center justify-center gap-2 overflow-hidden bg-[#7C46EF] border border-solid border-[#7C46EF] rounded-[10px] text-white shadow-2xl text-base font-medium uppercase transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-[10px] before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-full" 
          disabled={isLoading}
        ><span className="relative z-10 group-hover:text-white">
          {isLoading ? <span className="loader"></span> : "Submit"}
          </span>
        </button>

        {thankYouMessage && (
          <p className="text-center text-green-600 mt-3">{thankYouMessage}</p>
        )}
        {errorMessage && <p className="text-center text-red-600 mt-3 duration-75">{errorMessage}</p>}
      </form>
    </div>
  );
}
